<script>
  // 正式
  // const serverSrc='http://47.93.189.238:8081/api/open/upload-file/file-upload';
  // const imgurl="http://47.93.189.238:8081/api/open/upload-file/download?fileName=";
  // const codeurl="http://47.93.189.238:8081/api/open/imgcode";
  // const href="http://47.93.189.238:8081/api";
  
  // // 本地
  // const serverSrc = 'http://192.168.1.102:8082/api/open/upload-file/file-upload';
  // const imgurl = "http://192.168.1.102:8082/api/open/upload-file/download?fileName=";
  // const codeurl = "http://192.168.1.102:8082/api/open/imgcode";
  // const href = "http://192.168.1.102:8082/api";

  const serverSrc='https://api.gcphr.cn/api/open/upload-file/file-upload';
  const imgurl="https://api.gcphr.cn/api/open/upload-file/download?fileName=";
  const codeurl="https://api.gcphr.cn/api/open/imgcode";
  const href="https://api.gcphr.cn/api";

  
  const minheight = window.innerHeight - 130;
  // window.onresize = function () {

  //   minheight= window.innerHeight - 140;

  // }
  const tokens = '12345678';
  const hasEnter = false;
  export default
    {
      tokens,//用户token身份
      serverSrc,//服务器地址
      hasEnter,//用户登录状态
      imgurl,
      codeurl,
      minheight,
      href
    }
</script>


// WEBPACK FOOTER //
// src/common/common.vue